export const aboutContent = {
  title: "About Heartland Plains Chasing",
  subtitle: "A Kansas-based storm chasing team built on safety, trust, and field readiness.",
  description: `Heartland Plains Chasing was formed in 2026 by former members of Razorback Storm Chasing after internal leadership and safety concerns made it clear that a new team, new structure, and new brand were necessary. We do not associate with the former Razorback founder and are focused on building a safer, more transparent, team-oriented storm chasing organization.

Based in Kansas, our team documents severe weather across the plains with an emphasis on responsible chasing, clear communication, and respect for the communities affected by storms. Every chase begins with safety, planning, and accountability before anyone enters the field.

Heartland Plains Chasing exists to support weather awareness, share accurate field documentation, and grow a team culture where members can learn, contribute, and operate with confidence. The name is new, but the mission is direct: chase responsibly, document honestly, and communicate thoughtfully.`
};

export const socialLinks = {
  facebook: "https://www.facebook.com/people/Heartland-Plains-Chasing/61589810947137/",
  instagram: "https://www.instagram.com/heartlandplanschasing2026",
  twitter: "https://x.com/Heartlandplains",
  tiktok: "https://www.tiktok.com/@heartland.plains",
  youtube: "https://www.youtube.com/@heartlandplainschasing"
};
